<template>
  <div class="d-flex">
    <v-menu v-model="openColorPicker" :close-on-content-click="false" :position-y="positionY" :position-x="positionX">
      <v-color-picker
        mode="hexa"
        canvas-height="100"
        width="260"
        v-model="value"
        @input="handleChangeModel"
        :show-swatches="false"
        :hide-mode-switch="true"
      />
    </v-menu>

    <v-btn @click="handleOpenColorPicker" :color="value" class="mt-0 mr-2" fab x-small dark />

    <v-text-field v-model="value" :label="schema.label" dense hide-details />
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';

export default {
  mixins: [abstractField],

  data: () => ({
    openColorPicker: false,
    positionY: 0,
    positionX: 0
  }),

  methods: {
    handleOpenColorPicker(e) {
      this.positionX = e.pageX;
      this.positionY = e.pageY;

      this.openColorPicker = true;
    },

    handleChangeModel(e) {
      this.$emit('changeModel', e);
    }
  }
};
</script>
